
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/national",
      function () {
        return require("private-next-pages/national/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/national"])
      });
    }
  